export default __webpack_public_path__ + "static/media/640_dummy2016-pragentur01-de.b03b7e22.png";